import script from "./MemberWageHrManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberWageHrManagement.vue?vue&type=script&setup=true&lang=ts"

import "./MemberWageHrManagement.vue?vue&type=style&index=0&id=5f30519e&lang=scss"

const __exports__ = script;

export default __exports__